export default __webpack_public_path__ + "static/media/KevinMalone.51c6c202.jpg";